"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeToMarketTradeUpdated = exports.initMarketTradeSubscription = void 0;
var _marketTradeSubscriptionService = _interopRequireDefault(require("../../services/subscriptions/marketTradeSubscriptionService"));
var _snackbarActions = require("./snackbarActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var initMarketTradeSubscription = exports.initMarketTradeSubscription = function initMarketTradeSubscription() {
  return function (_dispatch) {
    _marketTradeSubscriptionService["default"].initSubscription();
  };
};

// Responsible for showing snackbar messages if instrument paused/resumed/halted/started
var subscribeToMarketTradeUpdated = exports.subscribeToMarketTradeUpdated = function subscribeToMarketTradeUpdated() {
  return function (dispatch, getState) {
    // Actually instrumentReducer already store SessionStatus of instrument which should be source of truth BUT
    // for some reason after capturing event that Instrument is paused server still returns this Instrument with
    // previous status. Looks like server sends an event while pausing/resuming is in progress.
    // This is why we store local copy of statuses here, another case is that server sends ~50 same events if SessionStatus
    // is changed, but we don't want to show 50 snackbars.
    var instruments = getState().apexCore.instrument.instruments.map(function (instrument) {
      return {
        InstrumentId: instrument.InstrumentId,
        Symbol: instrument.Symbol,
        SessionStatus: instrument.SessionStatus
      };
    });
    _marketTradeSubscriptionService["default"].subscribe(function (updates) {
      instruments.map(function (instrument) {
        if (instrument.InstrumentId === updates.VenueInstrumentId && instrument.SessionStatus !== updates.NewStatus) {
          instrument.SessionStatus = updates.NewStatus;
          var snackBar = getMarketUpdateSnackbar(instrument, updates);
          dispatch((0, _snackbarActions.showSnack)({
            id: snackBar.id,
            text: snackBar.text,
            type: snackBar.type
          }));
        }
        return instrument;
      });
    });
  };
};
var getMarketUpdateSnackbar = function getMarketUpdateSnackbar(instument, update) {
  var id = "OrderStateEventSnackbar-".concat(update.VenueInstrumentId, "-").concat(update.NewStatus);
  var type = 'info';
  var text = "Market for ".concat(instument.Symbol, " is ").concat(update.NewStatus);
  return {
    id: id,
    type: type,
    text: text
  };
};